/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BenutzerTelefonForAdmin { 
    telefon_id: string;
    nummer?: string;
    typ?: string;
    ist_sichtbar?: boolean;
}

